<template>
  <div>
    <v-card
      :to="itemLink"
      @mouseover="hover = true"
      @mouseleave="hover = false"
      dark
      shaped
      outlined
    >
      <v-img :src="dynamicLink" height="300px" />
      <v-card-title class="white--text title-cards-background text-h5">{{
        item.title
      }}</v-card-title>
      <v-card-text
        class="text-h6 text-cards-background"
        style="min-height:130px;"
      >
        <div class="pt-4">
          {{ item.text }}
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      scenesPath: /vergescenes/,
      route: 'Item',
      hover: false
    }
  },
  computed: {
    // generate dynamic catalogue picture on hover
    dynamicLink() {
      if (this.item.catalogueImage) {
        return `/images/catalogue/${this.item.catalogueImage}`
      }
      if (this.item.gif && this.hover) {
        return `${this.scenesPath}/${this.item.name}/thumbnail.gif`
      } else {
        return `${this.scenesPath}/${this.item.name}/thumbnail.jpg`
      }
    },
    itemLink() {
      if (!this.item.contentType) {
        // item is Verge3D component view
        // pass the item id as parameter ander render item.vue
        const routerLink = {
          name: 'Item',
          params: {
            sceneId: this.item.id
          }
        }
        return routerLink
      } else {
        // item is a pageView
        const routerLink = {
          name: this.item.routeName
        }
        return routerLink
      }
    }
  }
}
</script>

<style scoped>
/* .title-cards-background {
  background: linear-gradient(
    120deg,
    rgba(11, 35, 56, 0.966) 40%,
    #061c35 100%
  );
} */

.text-h2,
.text-h3,
.text-h4,
.text-h5,
.text-body-2,
.text-body-1 {
  font-family: 'Overlock' !important;
  text-shadow: 0px 0px 24px rgba(255, 255, 255, 0.88);
}

.text-h6 {
  font-family: 'Overlock' !important;
  /* line-height: 1.5rem !important; */
}

.title-cards-background {
  z-index: 100 !important;
  background-color: transparent !important;
  background: linear-gradient(
    234deg,
    rgba(12, 43, 70, 0.7) 24%,
    rgba(50, 100, 107, 0.7) 76%
  );
}

.text-cards-background {
  z-index: 100 !important;
  background-color: transparent !important;
  background: linear-gradient(234deg, rgba(12, 43, 70, 0.7) 44%, #081e33 76%);
}
</style>
